// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_pep","cls2":"PodcastLibraryCarouselAd-cls2_BUx PodcastLibraryCarouselAd-cls1_pep"};